<template>
    <div
        class="laptop:w-[850px] laptop:h-[55px] p-3 rounded-[10px] mx-[16px] laptop:mx-auto text-center flex justify-center items-start laptop:items-center gap-2.5 bg-[#FF00041A]/10 border-[1px] !border-[#FF000480]/50">
        <img src="../../assets/images/warn-icon.png" alt="Body Bg"
            class="w-[20px] laptop:w-[22px] h-[20px] laptop:h-[22px] mobile:hidden laptop:block object-cover">
        <p class="m-0 text-xs tablet:text-base font-roboto font-medium text-left !leading-[1.2]">You are acting on behalf of {{ user.user.full_name ?? 'Pro' }}. Any actions performed will affect {{ user.user.first_name }}’s account, and the activity will be recorded under {{ user?.proxied_by?.name ?? 'User' }}’s account.</p>
    </div>
</template>

<script>
import {
    mapGetters, mapActions
} from "vuex";

export default {
    computed: {
        ...mapGetters(["userObject"])
    },
    data() {
        return {
            user: JSON.parse(localStorage.getItem('user')) ?? null,
        };
    },
    watch: {
        userObject: function () {
            this.user = this.userObject
            localStorage.setItem('user', JSON.stringify(this.user))
        },
    }
}
</script>